import { render, staticRenderFns } from "./Watermark.vue?vue&type=template&id=be88c8d8&scoped=true"
import script from "./Watermark.vue?vue&type=script&lang=js"
export * from "./Watermark.vue?vue&type=script&lang=js"
import style0 from "./Watermark.vue?vue&type=style&index=0&id=be88c8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be88c8d8",
  null
  
)

export default component.exports